import { POSTS_A } from './posts-a';
import { POSTS_B } from './posts-b';
import { POSTS_C } from './posts-c';
import { POSTS_D } from './posts-d';
import { POSTS_E } from './posts-e';
import { POSTS_F } from './posts-f';
import { POSTS_G } from './posts-g';
import { POSTS_H } from './posts-h';
import { POSTS_I } from './posts-i';
import { POSTS_J } from './posts-j';
import { POSTS_K } from './posts-k';
import { POSTS_L } from './posts-l';

export const POSTS = [...POSTS_L, ...POSTS_K, ...POSTS_J, ...POSTS_I, ...POSTS_H, ...POSTS_G, ...POSTS_F, ...POSTS_E, ...POSTS_D, ...POSTS_A, ...POSTS_B, ...POSTS_C];

export const getPost = (slug) => POSTS.find((p) => p.slug === slug);

export const getRelatedPosts = (slug, count = 3) => {
  const current = getPost(slug);
  if (!current) return POSTS.slice(0, count);
  const sameCategory = POSTS.filter((p) => p.slug !== slug && p.category === current.category);
  const rest = POSTS.filter((p) => p.slug !== slug && p.category !== current.category);
  return [...sameCategory, ...rest].slice(0, count);
};
